var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.898 49.078h-9.6484v-16.359h9.7891c2.6602 0 4.6484 0.76953 6.0781 2.3594 1.5117 1.6797 2.2188 3.6797 2.2188 6.3008 0 2.4609-0.73047 4.3516-2.2188 5.7695-1.3789 1.3203-3.3516 1.9297-6.2188 1.9297zm-7.6367-2h7.6484c2.3203 0 3.8594-0.44141 4.8398-1.3789 1.0898-1.0391 1.6016-2.4102 1.6016-4.3203 0-2.1211-0.51953-3.6484-1.6992-4.9609-1.0508-1.1602-2.5117-1.6992-4.5898-1.6992h-7.7891v12.359z",
    fill: "#003102"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m83 96h-66c-7.1719 0-13-5.8281-13-13v-66c0-7.1719 5.8281-13 13-13h66c7.1719 0 13 5.8281 13 13v66c0 7.1719-5.8281 13-13 13zm-66-90c-6.0703 0-11 4.9297-11 11v66c0 6.0703 4.9297 11 11 11h66c6.0703 0 11-4.9297 11-11v-66c0-6.0703-4.9297-11-11-11z",
    fill: "#003102"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45.262 76.852h-14.449l-0.003906-53.703h22.102c4.3906 0 7.9688 0.69141 10.949 2.1211 3.3008 1.5781 5.7617 3.7109 7.5 6.5195 1.7891 2.8906 2.6602 6.0117 2.6602 9.5508 0 5.3203-1.8906 9.4883-5.7812 12.738-3.6797 3.0781-8.7617 4.5781-15.539 4.5781h-7.4414v18.191zm-12.453-2h10.449v-18.191h9.4414c6.2812 0 10.949-1.3398 14.25-4.1094 3.4102-2.8516 5.0703-6.5195 5.0586-11.211 0-3.1602-0.76953-5.9414-2.3594-8.5-1.5391-2.4688-3.7188-4.3594-6.6602-5.7695-2.6992-1.3008-6-1.9297-10.078-1.9297h-20.102z",
    fill: "#003102"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking3);
export default __webpack_public_path__ + "static/media/parking3.527cb791.svg";
export { ForwardRef as ReactComponent };